import photosGalleryService from 'src/services/photosGallery'

export default {
  updateType (type) {
    this.galeryQuery.type = type
  },
  updateSprint (sprint) {
    this.galeryQuery.sprint = sprint
  },
  updateLocationsIds (locationsIds) {
    this.galeryQuery.locationsIds = locationsIds
  },
  updateStartDate (startDate) {
    this.galeryQuery.startDate = startDate
  },
  updateEndDate (endDate) {
    this.galeryQuery.endDate = endDate
  },
  updateRoleId (roleId) {
    this.galeryQuery.roleId = roleId
  },
  updateUsersIds (usersIds) {
    this.galeryQuery.usersIds = usersIds
  },
  putCurrentSprint (payload) {
    this.currentSprint = payload
  },
  putCurrentForm (payload) {
    this.currentForm = payload
  },
  fetchSprintById (payload) {
    const promise = photosGalleryService.fetchSprintById(payload)

    promise.then(data => {
      this.currentSprintInfo = data
    })

    return promise
  },
  fetchTaskPhotosById (id) {
    const promise = photosGalleryService.fetchTaskPhotosById(id)

    promise.then(data => {
      this.imagesSprint = data
    })

    return promise
  },
  fetchTaskPhotosByGroup (payload) {
    const promise = photosGalleryService.fetchTaskPhotosByGroup(payload)

    promise.then(data => {
      this.imagesSprint = data
    })

    return promise
  },
  fetchTaskPhotosByGroupAndUser (payload) {
    const promise = photosGalleryService.fetchTaskPhotosByGroupAndUser(payload)

    promise.then(data => {
      this.imagesSprint = data
    })

    return promise
  },
  deleteSprintInfo (currentSprint) {
    this.currentSprintInfo = currentSprint
  },
  fetchFormsGallery () {
    const promise = photosGalleryService.fetchFormsGallery()

    promise.then(data => {
      this.recentForms = data
    })

    return promise
  },
  fetchFormById (payload) {
    const promise = photosGalleryService.fetchFormById(payload)

    promise.then(data => {
      this.currentFormInfo = data
    })

    return promise
  },
  fetchFormPhotosById (payload) {
    const promise = photosGalleryService.fetchFormPhotosById(payload)

    promise.then(data => {
      this.imagesForm = data
    })

    return promise
  }
}
